import { query_shop_list } from '@/api/mjstore-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '门店编码',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店编码',
    },
    {
      type: 'input',
      name: 'name',
      label: '门店名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店名称',
    },
    {
      type: 'remoteselect',
      name: 'area_id',
      label: '片区',
      disabled: false,
      placeholder: '请选择片区',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-area',
    },
    {
      type: 'input',
      name: 'phone',
      label: '门店电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店电话',
    },
    {
      type: 'input',
      name: 'address',
      label: '门店地址',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写门店地址',
    },
    {
      type: 'input',
      name: 'person_name',
      label: '门店负责人',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写负责人',
    },
    {
      type: 'input',
      name: 'person_phone',
      label: '负责人手机号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写负责人手机号',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    area_id: null,
    person_id: null,
    phone: null,
    address: null,
    person_name: null,
    person_phone: null,
    code: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '门店ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: '门店名称',
    width: 150,
    dataIndex: 'name',
    fixed: false,
    checked: true,
  },
  {
    title: '门店编码',
    width: 150,
    dataIndex: 'code',
    fixed: false,
    checked: true,
  },
  {
    title: '门店电话',
    width: 150,
    dataIndex: 'phone',
    fixed: false,
    checked: true,
  },
  {
    title: '门店地址',
    width: 150,
    dataIndex: 'address',
    fixed: false,
    checked: true,
  },
  {
    title: '门店负责人',
    width: 150,
    dataIndex: 'person_name',
    fixed: false,
    checked: true,
  },
  {
    title: '负责人手机号',
    width: 150,
    dataIndex: 'person_phone',
    fixed: false,
    checked: true,
  },
  {
    title: '片区ID',
    width: 150,
    dataIndex: 'area_id',
    fixed: false,
    checked: false,
  },
  {
    title: '名称',
    width: 150,
    dataIndex: 'area__name',
    fixed: false,
    checked: true,
  },
  {
    title: '出生日期',
    width: 150,
    dataIndex: 'birthday',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    fixed: false,
    checked: true,
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_shop_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
